import { render, staticRenderFns } from "./MessageImage.vue?vue&type=template&id=00fe068f&scoped=true&"
import script from "./message-image.ts?vue&type=script&lang=ts&"
export * from "./message-image.ts?vue&type=script&lang=ts&"
import style0 from "./MessageImage.vue?vue&type=style&index=0&id=00fe068f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fe068f",
  null
  
)

export default component.exports